import React from 'react';
import {
  ButtonWrapper,
  CardWrapper,
  InfoWrapper,
  Price,
  PriceLabel,
  Text,
  Title,
  TitleWrapper,
} from './PricingCard.styles';
import ButtonLink from '../interface/ButtonLink';

const PricingCard = ({ title, text, price, priceLabel, ctaText, ctaUrl }) => {
  return (
    <CardWrapper>
      <InfoWrapper>
        <TitleWrapper>
          <Title>{title}</Title>
          <div>
            <Price>€{price}</Price>
            <PriceLabel>{priceLabel}</PriceLabel>
          </div>
        </TitleWrapper>
        <Text>{text}</Text>
      </InfoWrapper>

      {ctaUrl && (
        <ButtonWrapper>
          <ButtonLink href={ctaUrl.url} type={ctaUrl.type} color="white" size="half">
            {ctaText}
          </ButtonLink>
        </ButtonWrapper>
      )}
    </CardWrapper>
  );
};

export default PricingCard;
